export default "__VITE_ASSET__BJ6gEkU4__"